export const MEDIA_CREDITS_TAG = 'media-credits';

export const ZRN_TOOLTIP_TITLE = 'Zillow Rental Number';
export const ZRN_TOOLTIP_COPY =
  'Each property has a unique Zillow Rental Number (ZRN). You’ll need this number when redeeming your media credits.';
export const MEDIA_CREDITS_MODAL_HEADING = 'Unused media credits';
export const MEDIA_CREDITS_EMPTY_STATE_MESSAGE = 'No eligible properties match this search.';
export const MEDIA_CREDITS_REDEEM_CTA_TEXT = 'Redeem media credits';
export const MEDIA_CREDITS_NO_ARYEO_COVERAGE_TITLE = 'Online ordering unavailable';
export const MEDIA_CREDITS_NO_ARYEO_COVERAGE_MESSAGE =
  'This property is outside Zillow Media Experts coverage. Please contact 3dtoursupport@zillowgroup.com to redeem.';
